import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { HttpBaseService } from 'src/app/base/http-base.service';
import * as menuActions from 'src/app/STORE/actions/menu.actions';

@Injectable()
export class MenuEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);

  getSidebarMenuItems$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(menuActions.getMenuData),
        map((action: any) => {
          return this.baseService.get(action.apiConstants).subscribe((menuData: any) => {
            this.store.dispatch(menuActions.setMenuData({ menuData }));
          });
        })
      ),
    {
      dispatch: false
    }
  );
}
